import { faPuzzlePiece } from "@fortawesome/pro-solid-svg-icons";
import { computed } from "vue";
import { usePropertyBuilder } from "../components/views/config/helpers";
import type { IUseMods } from "../components/views/mods";
import { useSteamWorkshop } from "../components/views/mods/steam_workshop";
import type { SoulmaskProfileNamespace, SteamWorkshopItem } from "../graphql";
import { useServiceStore } from "../store/service";
import { getSoulmaskClusterCommitBlockedMessageKey } from "../util/soulmaskClusterValidation";
import { commonMenuItems } from "./common";
import defaultProfile, { asyncRoute } from "./default";
import type { ConfigSection, GameProfile, Menu, ProfileCtx } from "./types";
import { MenuItem } from "./types";

const configSections: ConfigSection[] = [
  { component: "ConfSection", props: { name: "basic" } },
  { component: "SoulmaskCluster", props: { name: "cluster" } },
  { component: "TableSection", props: { name: "rcon_ips" } },
  { component: "ConfSection", props: { name: "extended" } },
  { component: "SoulmaskPermissions", props: { name: "permissions" } },
];

const createMenu = (): Menu => {
  const menu = defaultProfile().menu;
  menu[0].items.push(
    commonMenuItems.logs,
    new MenuItem(
      "workshop",
      faPuzzlePiece,
      asyncRoute(() => import("../components/views/config/soulmask/workshop/Workshop.vue")),
      [
        {
          route: "manage",
          component: asyncRoute(() => import("../components/views/mods/manage/ModsManage.vue")),
        },
      ],
    ),
  );

  return menu;
};

function useMods() {
  const service = useServiceStore();
  const { buildProperty } = usePropertyBuilder();

  const profile = computed(() => service.ctx.profile as SoulmaskProfileNamespace | undefined);
  const selectedWorkshopItems = computed(() => profile.value?.selectedWorkshopItems ?? []);
  const subscribedFileIds = buildProperty<Array<string>>("virtual", "mods", []);
  const collectionsStub = computed({
    get() {
      return [];
    },
    set() {},
  });
  return useSteamWorkshop(selectedWorkshopItems, subscribedFileIds, collectionsStub);
}

function soulmaskCommitBlockedMessageKey(): string | null {
  const service = useServiceStore();
  const virtual = service.ctx.profile?.publicConfigs?.virtual as Record<string, unknown> | undefined;
  return getSoulmaskClusterCommitBlockedMessageKey(virtual);
}

export default (_ctx: ProfileCtx): Partial<GameProfile<SteamWorkshopItem, IUseMods<SteamWorkshopItem>>> => ({
  configSections,
  useMods,
  menu: createMenu(),
  commitBlockedMessageKey: soulmaskCommitBlockedMessageKey,
});
